<div class="pnl-settings-banner-register">
  <header>
      <a [routerLink]="['/app/configuracao/design/banners']" class="back">Banner</a>
  </header>

  <form [formGroup]="bannerFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="publication">
        <strong>Publicação</strong>
        <span>
          Publique ou despublique o banner
        </span>
        <div class="ipt-switch">
            <input [id]="publicado" formControlName="publicado" (change)="onChangeDetail()" name="publicado" type="checkbox" value="S">
            <label [for]="publicado"></label>
        </div>
      </div>

      <div class="region">
        <strong>Região</strong>
        <span>
          Informe a região que o banner será inserido
        </span>
        <div>
          <ng-select *ngIf="showText.value == false" [items]="regions" (change)="onChangeDetail()"  (clear)="onClearRegion()" formControlName="local" placeholder="Selecione" bindLabel="descricao" bindValue="local"></ng-select>
          <input *ngIf="showText.value == true" formControlName="local_ds" (change)="onChangeDetail()" type="text" class="form-control">
          <button *ngIf="showText.value == false" (click)="toogleRegion()" type="button" class="btn btn-warning-outline">nova</button>
          <button *ngIf="showText.value == true" (click)="toogleRegion()" type="button" class="btn btn-warning-outline">selecionar</button>
        </div>
      </div>

      <div *ngIf="publicado.value">
        <strong>Programação</strong>
        <div>
          <mat-radio-group formControlName="select_program">
            <mat-radio-button name="select_program" value="1">Definir uma data para iniciar e outra para expirar</mat-radio-button>
            <mat-radio-button name="select_program" value="2">Escolher um dia da semana para mostrar automaticamente</mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="select_program.value == 1" class="range-date">
          <div>
            <label>Data de início</label>
            <div class="frm-datepicker">
                <input type="text" formControlName="dt_start" class="form-control" (dateInput)="onChangeDetail()" [matDatepicker]="pickerInicialDate" />
                <mat-datepicker-toggle matSuffix [for]="pickerInicialDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicialDate></mat-datepicker>
            </div>
          </div>
          <div>
            <label>Data expiração</label>
            <div class="frm-datepicker">
              <input type="text" formControlName="dt_expired" [min]="dt_start.value" (dateInput)="onChangeDetail()" class="form-control" [matDatepicker]="pickerDtEnd" />
              <mat-datepicker-toggle matSuffix [for]="pickerDtEnd"></mat-datepicker-toggle>
              <mat-datepicker #pickerDtEnd></mat-datepicker>
            </div>
          </div>
        </div>
        <div *ngIf="select_program.value == 2" class="days">
          <ul>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_monday" formControlName="diasemana_monday" (change)="onChangeDays(diasemana_monday)" name="diasemana_monday" type="checkbox" value="1">
                <label for="diasemana_monday"></label>
              </div>
              <label for="diasemana_monday">
                Mostrar em todas as Segundas-feiras
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_tuesday" formControlName="diasemana_tuesday" (change)="onChangeDays(diasemana_tuesday)" name="diasemana_tuesday" type="checkbox" value="2">
                <label for="diasemana_tuesday"></label>
              </div>
              <label for="diasemana_tuesday">
                Mostrar em todas as Terças-feiras
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_wednesday" formControlName="diasemana_wednesday" (change)="onChangeDays(diasemana_wednesday)" name="diasemana_wednesday" type="checkbox" value="3">
                <label for="diasemana_wednesday"></label>
              </div>
              <label for="diasemana_wednesday">
                Mostrar em todas as Quartas-feiras
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_thursday" formControlName="diasemana_thursday" (change)="onChangeDays(diasemana_thursday)" name="diasemana_thursday" type="checkbox" value="4">
                <label for="diasemana_thursday"></label>
              </div>
              <label for="diasemana_thursday">
                Mostrar em todas as Quintas-feiras
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_friday" formControlName="diasemana_friday" (change)="onChangeDays(diasemana_friday)" name="diasemana_friday" type="checkbox" value="5">
                <label for="diasemana_friday"></label>
              </div>
              <label for="diasemana_friday">
                Mostrar em todas as Sextas-feiras
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_saturday" formControlName="diasemana_saturday" (change)="onChangeDays(diasemana_saturday)" name="diasemana_saturday" type="checkbox" value="6">
                <label for="diasemana_saturday"></label>
              </div>
              <label for="diasemana_saturday">
                Mostrar em todos os Sábados
              </label>
            </li>
            <li>
              <div class="ipt-switch">
                <input id="diasemana_sunday" formControlName="diasemana_sunday" (change)="onChangeDays(diasemana_sunday)" name="diasemana_sunday" type="checkbox" value="7">
                <label for="diasemana_sunday"></label>
              </div>
              <label for="diasemana_sunday">
                Mostrar em todos os Domingos
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="image-wrapper">
          <div class="image-dragged image-dragged-desktop" ng2FileDrop [uploader]="uploader" (fileOver)="fileOverBase($event)" [class.dnone]="((image!='') || (uploader.queue && uploader.queue.length > 0))" [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }">
            <i class="ic ic-no-image-medium"></i>
            <strong>Arraste e solte aqui a imagem do banner para versão desktop <b *ngIf="local.value=='RT' && !this.showText.value">1200 x 360</b></strong>
            <input id="fileUploader" #fileUploader type="file" ng2FileSelect [uploader]="uploader" class="dnone">
            <button (click)="fileUploader.click()" type="button" class="btn btn-primary-outline">ou clique aqui para buscar</button>
          </div>

          <div *ngIf="((uploader.queue && uploader.queue.length > 0) || image != '')" class="image-cover image-cover-desktop">
            <div class="actions">
              <a (click)="onRemoveImage('')"><i class="ic ic-delete"></i>Excluir imagem</a>
              <a [href]="image" target="_blank"><i class="ic ic-download"></i>Baixar imagem</a>
            </div>
            <img [src]="image" *ngIf="image!=''" />
            <span *ngFor="let item of uploader.queue; let i=index" >
              <img *ngIf="isImage(item.file)" src="" imgPreview [image]="item?._file">
              <video *ngIf="isVideo(item.file)" src="" autoplay videoPreview [movie]="item?._file"></video>
            </span>
          </div>

          <div class="image-dragged image-dragged-mobile" ng2FileDrop [uploader]="uploader_mobile" (fileOver)="fileOverBaseMobile($event)" [class.dnone]="((image_mobile!='') || (uploader_mobile.queue && uploader_mobile.queue.length > 0))" [ngClass]="{ 'nv-file-over': hasBaseDropZoneOverMobile }">
            <i class="ic ic-no-image-medium"></i>
            <strong>Arraste e solte aqui a imagem do banner para versão mobile <b *ngIf="local.value=='RT' && !this.showText.value">400 x 120</b></strong>
            <input id="fileUploaderMobile" #fileUploaderMobile type="file" ng2FileSelect [uploader]="uploader_mobile" class="dnone">
            <button (click)="fileUploaderMobile.click()" type="button" class="btn btn-primary-outline">ou clique aqui para buscar</button>
          </div>

          <div *ngIf="((uploader_mobile.queue && uploader_mobile.queue.length > 0) || image_mobile != '')" class="image-cover image-cover-mobile">
            <div class="actions">
              <a (click)="onRemoveImage('mobile')"><i class="ic ic-delete"></i>Excluir imagem</a>
              <a [href]="image_mobile" target="_blank"><i class="ic ic-download"></i>Baixar imagem</a>
            </div>
            <img [src]="image_mobile" *ngIf="image_mobile!=''" />
            <img *ngFor="let item of uploader_mobile.queue; let i=index" src="" imgPreview [image]="item?._file" />
          </div>

        </div>

        <div class="infos">
          <div>
            <label>Título <i>(legenda da imagem)</i></label>
            <input type="text" class="form-control mb20" formControlName="titulo" (keyup)="onChangeDetail()" placeholder="Ex.: Queijos e vinhos para o inverno" />

            <label>URL <i>(link)</i></label>
            <input type="text" class="form-control"  formControlName="link_url" (keyup)="onChangeDetail()" placeholder="Url" />
          </div>

          <div>
            <label>Acessibilidade <i>(descreva a imagem usando o hífen entre palavras)</i></label>
            <input type="text" class="form-control mb20" formControlName="acessibilidade" (keyup)="onChangeDetail()" placeholder="sabor-inverno-queijos-vinhos-toda-quinta" />

            <label>Destino da URL</label>
            <ng-select class="ng-select-visible" [items]="url_destiny" formControlName="target" (change)="onChangeDetail()" bindLabel="label" bindValue="value"></ng-select>
          </div>
        </div>
      </div>
    </section>
  </form>
  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button *ngIf="banner && banner.idbanner && banner.idbanner > 0" (click)="onCancel()" class="btn btn-primary-outline">Cancelar</button>
      <button (click)="onSubmit()" class="btn btn-primary">Salvar</button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
  </div>
</div>
